import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  BarElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

function YearlyContribution({ chart_data }) {
  const [data, setData] = useState({});
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (!chart_data || chart_data.length === 0) return;

    const labels = chart_data.map((item) => item.year);

    const targetData = chart_data.map((item) =>
      Number((item.target / 10000000).toFixed(2))
    );

    const revenueData = chart_data.map((item) =>
      Number((item.total_revenue / 10000000).toFixed(2))
    );

    setData({
      labels,
      datasets: [
        {
          type: "bar", // ✅ BAR
          label: "Target",
          data: targetData,
          backgroundColor: "#f6ab49",
          borderRadius: 8,
          order: 2,
        },
        {
          type: "line", // ✅ LINE
          label: "Revenue",
          data: revenueData,
          borderColor: "#36A2EB",
          backgroundColor: "#36A2EB",
          tension: 0.4, // smooth curve
          pointRadius: 4,
          pointHoverRadius: 6,
          fill: false,
          borderWidth: 3, 
          order: 1,
        },
      ],
    });

    setOptions({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "top",
        },
        tooltip: {
          callbacks: {
            label: (context) =>
              `${context.dataset.label}: ₹ ${Number(context.raw).toFixed(2)} Cr`,
          },
        },
      },
      scales: {
        y: {
          ticks: {
            callback: (value) => `₹ ${Number(value).toFixed(2)} Cr`,
          },
        },
      },
    });
  }, [chart_data]);

  return (
    <div style={{ width: "100%", height: "300px" }}>
      {data?.datasets && <Chart type="bar" data={data} options={options} />}
    </div>
  );
}

export default YearlyContribution;